<template>
    <span v-if="hasCreateConsultationAccess">
        <b-button :variant="variant" :size="size || undefined" :disabled="isDisabled" @click="open">
            <span>Create Consultation</span>
            <i v-if="showIcon" class="fas fa-comment-medical"></i>
        </b-button>
        <b-modal :id="modalId" hide-footer no-close-on-backdrop size="lg" title="New Consultation" lazy>
            <NewConsultationFormComponent v-if="patient && patient.id && store && store.id" :patient="patient"
                :store="store" :prefilled-prescription="prescription" @updateList="onConsultationCreated" />
        </b-modal>
    </span>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import NewConsultationFormComponent from "@/components/Consultation/NewConsultationFormComponent.vue";
import { Patient } from "@/models/Patient";
import { Store } from "@/models/Store";
import { Prescription } from "@/models/Prescription";

@Component({
    name: "CreateConsultationButton",
    components: {
        NewConsultationFormComponent,
    },
})
export default class CreateConsultationButton extends Vue {
    @Prop() private patient!: Patient;
    @Prop({ default: null }) private store!: Store | null;
    @Prop({ default: null }) private prescription!: Prescription | null;
    @Prop({ default: "info" }) private variant!: string;
    @Prop({ default: null }) private size!: string | null;
    @Prop({ default: false }) private showIcon!: boolean;

    get modalId(): string {
        return `inline-new-consultation-${(this as any)._uid}`;
    }

    get hasCreateConsultationAccess(): boolean {
        return this.$permissions.some(p => p.permissionCodeName === "Consultations/Create Consultation");
    }

    // The consultation is linked to the prescription solely via its rxNumber, so require one
    // before allowing creation — otherwise the consultation is saved unlinked.
    get isDisabled(): boolean {
        return !this.patient?.id || !this.store?.id || !this.prescription?.rxNumber;
    }

    open() {
        this.$bvModal.show(this.modalId);
    }

    onConsultationCreated() {
        this.$bvModal.hide(this.modalId);
        this.$emit("created");
    }
}
</script>
